/** Filipino: Workflows P5-1, connectors on the canvas. */
export const workflowsConnectors = {
  pathExit: "Papunta sa",
  exitsOf: "Mga labasan ng {{step}}",
  to: "→ {{path}}",
  missingPath: "Nawawala ang Path {{id}}",
  fallback: { next: "Susunod na hakbang", end: "Nagtatapos", unset: "Pumili ng path" },
  after: { next: "ay papunta sa susunod na hakbang", end: "ay nagtatapos sa workflow", unset: "ay nangangailangan ng path" },
  handle: {
    connected: "Labasan na “{{exit}}” ng {{step}} sa {{path}}: papunta sa {{target}}",
    missing: "Labasan na “{{exit}}” ng {{step}} sa {{path}}: papunta sa Path {{id}}, na wala na",
    next: "Labasan na “{{exit}}” ng {{step}} sa {{path}}: walang koneksyon, susunod na hakbang ang kasunod",
    end: "Labasan na “{{exit}}” ng {{step}} sa {{path}}: walang koneksyon, nagtatapos ang workflow",
    unset: "Labasan na “{{exit}}” ng {{step}} sa {{path}}: walang koneksyon, pumili ng path",
  },
  menu: {
    label: "Koneksyon ng “{{exit}}”",
    goTo: "Pumunta sa {{path}}",
    connectTo: "Ikonekta sa",
    newPath: "Bagong path",
    connected: "Nakakonekta",
    delete: "Burahin ang koneksyon",
    deleteKeys: "Del",
  },
  drop: "Bitawan para ikonekta",
  reasons: {
    self: "Parehong path",
    loop: "Iikot nang walang paghihintay",
    trigger: "Hindi ang trigger",
    full: "Gamit na ang lahat ng {{max}} path",
  },
  refused: {
    self: "Hindi maaaring bumalik ang labasan sa sarili nitong path.",
    loop: "Iikot ang path nang hindi naghihintay sa bisita. Path lang na naghihintay ng sagot ang maaaring umikot.",
    trigger: "Walang maaaring tumuloy sa trigger: ito ang nagsisimula ng workflow.",
    full: "Gamit na ang lahat ng {{max}} path. Magbura muna bago magdagdag.",
  },
  announce: {
    dragging: "Ikinokonekta ang “{{exit}}”. Bitawan ito sa isang path, o sa bakanteng canvas para gumawa ng bagong path. Kinakansela ng Escape.",
    connected: "Papunta na sa {{path}} ang “{{exit}}”.",
    created: "Nagawa ang Path {{id}} at nakakonekta rito ang “{{exit}}”.",
    deleted: "Nabura ang koneksyon. Ang “{{exit}}” {{after}}.",
    cancelled: "Kinansela ang pagkokonekta.",
    wentTo: "Lumipat sa {{path}}.",
  },
} as const;
